import React from "react";
import { FiArrowRight, FiBookOpen, FiBriefcase, FiFileText, FiFolder, FiGrid, FiLayers } from "react-icons/fi";
import DealDeskGuide from "./DealDeskGuide";
import "../../Components/css/DealDeskWorkspace.css";
import "./DealDeskShell.guide.css";

export const DEAL_DESK_APPS = [
  { id: "documentation", label: "Documentation", shortLabel: "Docs", icon: FiBookOpen },
  { id: "sow", label: "SOW", shortLabel: "SOW", icon: FiFileText },
  { id: "ideas", label: "Idea Builder", shortLabel: "Ideas", icon: FiLayers },
  { id: "projects", label: "Project Management", shortLabel: "Projects", icon: FiBriefcase },
  { id: "assets", label: "Assets", shortLabel: "Assets", icon: FiFolder },
];

export const workspaceAppFromUrl = () => {
  const app = new URLSearchParams(window.location.search).get("app");
  return DEAL_DESK_APPS.some(item => item.id === app) ? app : "home";
};

export default function DealDeskShell({ activeApp, children, onAppChange, projectName, projectLogo }) {
  const currentApp = DEAL_DESK_APPS.find(app => app.id === activeApp);
  return <div className="sow-workspace-shell deal-desk deal-desk--guided">
    <a href="#deal-desk-content" className="deal-desk__skip">Skip to workspace</a>
    <header className="deal-desk__header">
      <div className="deal-desk__identity">
        <img className="deal-desk__brand" src="/assets/antrazal-brand.svg" alt="Antrazal" />
        <div className="deal-desk__context" title={projectName}><span>Deal Desk</span>{projectLogo || <strong>{projectName}</strong>}</div>
      </div>
      <button type="button" className="deal-desk__apps-button" aria-label="All apps" title="All apps"
        aria-current={activeApp === "home" ? "page" : undefined} onClick={() => onAppChange("home")}>
        <FiGrid aria-hidden="true" /><span>Apps</span>
      </button>
      {currentApp && <span className="deal-desk__current-app">{currentApp.label}</span>}
      {currentApp && <DealDeskGuide key={currentApp.id} app={currentApp} />}
    </header>
    <div className="deal-desk__content" id="deal-desk-content" tabIndex={-1}>
      {activeApp === "home" && <main className="deal-desk__launcher">
        <header><h1>{projectName} workspace</h1></header>
        <nav className="deal-desk__app-grid" aria-label="Workspace apps">
          {DEAL_DESK_APPS.map(({ id, label, icon: Icon }) => <button key={id} type="button"
            className={`deal-desk__launch-app deal-desk__launch-app--${id}`} onClick={() => onAppChange(id)}>
            <span className="deal-desk__launch-icon"><Icon aria-hidden="true" /></span>
            <span>{label}</span><FiArrowRight className="deal-desk__launch-arrow" aria-hidden="true" />
          </button>)}
        </nav>
      </main>}
      {children}
    </div>
  </div>;
}
